const initState = {
    isLoading: false,
    data: [],
    error: null,
}

export default function QuickTranscationReducer(state = initState, action) {
    switch (action.type) {
        case "SET_QUICK_LOADING_TRANS":
            return {
                ...state,
                isLoading: true,
            }
        case "SET_QUICK_DATA_TRANS":
            return {
                ...state,
                data: action.payload,
                isLoading: false,
            }
        case "SET_QUICK_ERROR_TRANS":
            return {
                ...state,
                error: action.payload,
                isLoading: false,
            }
        case "CLEAR_QUICK":
            return {
                ...state,
                data: [],
                isLoading: false,
                error: null,
            }
        default:
            return state
    }
}